var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content",class:[_vm.contain ? 'is-contain' : '', _vm.titlePage ? 'is-title-page' : '', _vm.noOverlay ? '' : 'overlay', _vm.fullWidth ? '' : 'set-width']},[_vm._t("page")],2)}
var staticRenderFns = []

export { render, staticRenderFns }